// Keep the selected subscription when switching between login and signup.
export function getAuthRedirect(query = {}) {
  return typeof query.redirect === 'string' && query.redirect.startsWith('/app/')
    ? query.redirect
    : undefined;
}
